// @core/api/endpoints/tenant/reactivate_tenant.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ReactivateTenantRequest,
  TenantResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Reactivate suspended tenant
 * Reactivates a previously suspended tenant, restoring full access to its resources. Platform admin verifies that suspension conditions have been resolved before reactivation.
 */
export async function ReactivateTenant(
  tenant_id: string,
  data: ReactivateTenantRequest,
  options?: RequestOptions
): Promise<TenantResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/reactivate`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.post<TenantResponse>(requestPath, data, requestOptions);
}
